import { Component, Input, EventEmitter, Output } from "@angular/core";
import { WizardSubstep } from "../../../common/wizard/wizard-subtep.interface";
import { RecurringType } from "../../../../domain/enums";
import { AutopilotRule } from "../../../../domain/rule";

@Component({
  selector: "icn-autopilot-rule-wizard-step2-substep1",
  templateUrl: "./substep1.html",
  styleUrls: ["./substep1.scss"],
})
export class AutopilotRuleWizardStep2Substep1Component
  implements WizardSubstep
{
  options = [
    {
      name: "Time Based (The media will be played in intervals)",
      value: RecurringType.Time,
    },
    {
      name: "Video based (The media will be added to selected videos)",
      value: RecurringType.Video,
    },
    {
      name: "Always show (The media will be always visible)",
      value: RecurringType.Always,
    },
  ];

  @Input()
  rule: AutopilotRule;

  canGoNext() {
    return !!this.rule.recurringType;
  }
}
